import React, { useState } from 'react'
// import './auth.css'
import { Logo } from 'assets'
import { useSocialLoginHook } from 'Hooks'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { convertObjectToFormData } from 'utils/convertFormData'
import { loginAction } from 'store/action/AuthRedux'
import { LoginTypeConstObj } from 'constant/const'
import { Loader, PrivacyTerms } from 'components'

function InstagramLogin() {
   const authData = useSelector((state) => state.user)
   const { userData, loading, loginType } = authData
   const navigate = useNavigate()
   const { googleLogin } = useSocialLoginHook()
   const method = useForm()

   const {
      handleSubmit,
      register,
      formState: { errors }
   } = method
   const dispatch = useDispatch()

   useEffect(() => {
      if (loginType === LoginTypeConstObj.google) {
         if (userData && userData?.access) {
            // if (!userData?.is_privacy_checked) {
            //    setOpenPrivacyPolicyModal(true)
            // } else
            if (!userData?.is_channel_exists) {
               navigate('/auth/add-channel')
            } else {
               navigate('/dashboard')
            }
         }
      } else if (loginType === LoginTypeConstObj.instagram) {
         if (userData && userData?.access) {
            navigate('/instagram/dashboard')
         }
      }
      return () => {}
   }, [userData, loginType])

   const onSubmit = (data) => {
      let formData = convertObjectToFormData(data)
      dispatch(loginAction(formData))
   }

   return (
      <>
         <div className="auth-section p-3 position-relative min-vh-100">
            {loading && <Loader />}
            <div className="auth-wrap">
               <div className="form-section-wrap">
                  <div className="logo-section">
                     <img src={Logo} alt="logo" />
                  </div>
                  <form>
                     <div className="form-section ">
                        <h1 className="at-text-dark add-channel">Welcome to Atenya!</h1>

                        <a
                           //
                           href={`https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=${process.env.REACT_APP_INSTAGRAM_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_INSTAGRAM_LOGIN_REDIRECT_URI}&response_type=code&scope=instagram_business_basic%2Cinstagram_business_manage_messages%2Cinstagram_business_manage_comments%2Cinstagram_business_content_publish%2Cinstagram_business_manage_insights`}
                           className="atenya-btn mt-3 ">
                           {/* <GoogleIcon /> */}
                           <span>Log in with Instagram</span>
                        </a>
                        <Link
                           className="mt-3 d-inline-block text-decoration-underline connect-link"
                           to={'/auth/login'}
                           target="_blank">
                           {/* <GoogleIcon /> */}
                           <span>Connect with Google </span>
                        </Link>
                     </div>
                  </form>
                  <PrivacyTerms />
               </div>
               <div className="d-none d-lg-block right-side-section  ">
                  <div className="auth-bg-image"></div>
               </div>
            </div>
         </div>
      </>
   )
}

export default InstagramLogin
